import { Components, Theme } from '@mui/material'

export const MuiCircularProgress: Components<Omit<Theme, 'components'>>['MuiCircularProgress'] = {
  styleOverrides: {
    circleDeterminate: {
      strokeLinecap: 'round',
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: ({ theme }) => ({
        color: theme.palette.fg.brand.default,
      }),
    },
    {
      props: { color: 'secondary' },
      style: ({ theme }) => ({
        color: theme.palette.fg.subtle,
      }),
    },
    {
      props: { color: 'success' },
      style: ({ theme }) => ({
        color: theme.palette.fg.success.default,
      }),
    },
  ],
}
